const ExpertProjectsIndex  = () => import('./index.vue')
const CreateProjectPage = () => import('./_pages/create_project')
const ExpertProjectDetails = () => import('./_pages/details')
import { CheckExpertGuard, CheckAuth } from '@/common/guard'

export default [
    {
        path: '/expert/projects',
        beforeEnter: CheckExpertGuard,
        component: ExpertProjectsIndex,
        name: 'ExpertProjectsIndex'
    },
    { 
        path: '/expert/project/details/:id',
        beforeEnter: CheckExpertGuard,
        component: ExpertProjectDetails,
        name: 'ExpertProjectDetails'
    },
    {
        path: '/expert/create/project',
        beforeEnter: CheckExpertGuard,
        component: CreateProjectPage,
        name: 'CreateProjectPage'
    }
]